import axios from 'axios';
import appService from '../../services/appService';

export const aiImport = {
    namespaced: true,
    state: {
        lists: [],
        page: {},
        pagination: [],
        show: {},
    },
    getters: {
        lists: function (state) {
            return state.lists;
        },
        pagination: function (state) {
            return state.pagination;
        },
        page: function (state) {
            return state.page;
        },
        show: function (state) {
            return state.show;
        },
    },
    actions: {
        preview: function (context, payload) {
            return new Promise((resolve, reject) => {
                axios.post('admin/product/ai-import/preview', payload.form).then((res) => {
                    resolve(res);
                }).catch((err) => reject(err));
            });
        },
        lists: function (context, payload) {
            return new Promise((resolve, reject) => {
                let url = 'admin/product/ai-import';
                if (payload) {
                    url = url + appService.requestHandler(payload);
                }

                axios.get(url).then((res) => {
                    context.commit('lists', res.data.data);
                    context.commit('page', res.data.meta);
                    context.commit('pagination', res.data);
                    resolve(res);
                }).catch((err) => reject(err));
            });
        },
        create: function (context, payload) {
            return new Promise((resolve, reject) => {
                axios.post('admin/product/ai-import', payload.form).then((res) => {
                    context.dispatch('lists', payload.search).then().catch();
                    resolve(res);
                }).catch((err) => reject(err));
            });
        },
        show: function (context, payload) {
            return new Promise((resolve, reject) => {
                axios.get(`admin/product/ai-import/show/${payload}`).then((res) => {
                    context.commit('show', res.data.data);
                    resolve(res);
                }).catch((err) => reject(err));
            });
        },
        updateItem: function (context, payload) {
            return new Promise((resolve, reject) => {
                axios.patch(`admin/product/ai-import/item/${payload.id}`, payload.form).then((res) => {
                    resolve(res);
                }).catch((err) => reject(err));
            });
        },
        start: function (context, payload) {
            return new Promise((resolve, reject) => {
                const id = typeof payload === 'object' ? payload.id : payload;
                const form = typeof payload === 'object' ? (payload.form || {}) : {};

                axios.post(`admin/product/ai-import/start/${id}`, form).then((res) => {
                    context.commit('show', res.data.data);
                    resolve(res);
                }).catch((err) => reject(err));
            });
        },
        updateSnapshot: function (context, payload) {
            return new Promise((resolve, reject) => {
                const id = typeof payload === 'object' ? payload.id : payload;
                const form = typeof payload === 'object' ? (payload.form || {}) : {};

                axios.post(`admin/product/ai-import/snapshot/${id}`, form).then((res) => {
                    context.commit('show', res.data.data);
                    resolve(res);
                }).catch((err) => reject(err));
            });
        },
        confirmItem: function (context, payload) {
            return new Promise((resolve, reject) => {
                axios.post(`admin/product/ai-import/confirm-item/${payload}`).then((res) => {
                    resolve(res);
                }).catch((err) => reject(err));
            });
        },
        purgeFailed: function (context, payload) {
            return new Promise((resolve, reject) => {
                axios.delete(`admin/product/ai-import/failed/${payload}`).then((res) => {
                    resolve(res);
                }).catch((err) => reject(err));
            });
        },
        deleteItem: function (context, payload) {
            return new Promise((resolve, reject) => {
                axios.delete(`admin/product/ai-import/item/${payload}`).then((res) => {
                    resolve(res);
                }).catch((err) => reject(err));
            });
        },
        resetShow: function (context) {
            context.commit('show', {});
        }
    },
    mutations: {
        lists: function (state, payload) {
            state.lists = payload;
        },
        pagination: function (state, payload) {
            state.pagination = payload;
        },
        page: function (state, payload) {
            if (typeof payload !== 'undefined' && payload !== null) {
                state.page = {
                    from: payload.from,
                    to: payload.to,
                    total: payload.total
                };
            }
        },
        show: function (state, payload) {
            state.show = payload;
        }
    }
};
